import React from "react";
import {observer} from "mobx-react";
import {useServices} from "../../../../hooks/use-services.hook";
import {PayPalMessagesComponentOptions} from "@paypal/paypal-js";
import {PayPalMessages} from "@paypal/react-paypal-js";
import styled from "styled-components";

const PayLaterBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    justify-items: center;
    width: 100%;
`

export const PaypalPayLaterComponent: React.FC = observer(() => {
    const services = useServices();
    const booking = services.booking.current;
    if(!services.configuration.isPayPalPayLaterEnabled) {
        return null;
    }


    const messagesProps: PayPalMessagesComponentOptions = {
        placement: "payment",
        amount: booking.balanceDue.amount,
        currency: (booking.balanceDue.currency as any),
        style: {
            color: "white-no-border",
            layout: "text",
            ratio: "1x1",
            text: {
                size: 16,
                align: "center",
            }
        }
    }
    return (
        <PayLaterBox>
            <PayPalMessages {...messagesProps} forceReRender={[messagesProps.style]} />
        </PayLaterBox>

    )
})